import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '@mulesoft/anypoint-icons/lib/Icon';
import GridIcon from '@mulesoft/anypoint-icons/lib/svg/grid.svg';
import ListIcon from '@mulesoft/anypoint-icons/lib/svg/bullet.svg';
import * as qs from '~/utils/queryString';
import styles from './ViewSwitcher.css';

class ViewSwitcher extends React.Component {
  static propTypes = {
    query: PropTypes.object,
    className: PropTypes.string,
    pathname: PropTypes.string,
    onSwitch: PropTypes.func
  };

  onSwitch(view) {
    return () => {
      const { onSwitch } = this.props;

      onSwitch(view);
    };
  }

  render() {
    const { query = {}, pathname = '/', className } = this.props;
    const isListView = query.view === 'list';

    return (
      <nav
        aria-label="Asset view mode"
        className={classNames(styles.viewSwitcher, className)}
      >
        <Link
          className={classNames(styles.iconWrapper, {
            [styles.active]: !isListView
          })}
          to={`${pathname}?${qs.stringify({ ...query, view: 'grid' })}`}
          onClick={this.onSwitch('grid')}
          aria-current={!isListView ? 'true' : undefined}
          data-test-id="grid-switch-wrapper"
        >
          <Icon size="xs" isDecorative>
            <GridIcon />
          </Icon>
          <span className={styles.label}>View grid</span>
        </Link>
        <Link
          className={classNames(styles.iconWrapper, {
            [styles.active]: isListView
          })}
          to={`${pathname}?${qs.stringify({ ...query, view: 'list' })}`}
          onClick={this.onSwitch('list')}
          aria-current={isListView ? 'true' : undefined}
          data-test-id="list-switch-wrapper"
        >
          <Icon size="xs" isDecorative>
            <ListIcon />
          </Icon>
          <span className={styles.label}>View list</span>
        </Link>
      </nav>
    );
  }
}

export default ViewSwitcher;
